var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeartFavoriteFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 36 36",
    "aria-labelledby": "heartFavoriteFullIcon heartFavoriteFullDesc",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.068 11.097c1.23-1.352 3.24-2.113 5.163-1.921 2.698.27 4.519 2.287 4.519 5.574 0 2.689-3.085 6.63-9.254 12.063a.75.75 0 01-.985.006C11.342 21.507 8.25 17.556 8.25 14.75c0-3.287 1.821-5.304 4.52-5.574 1.921-.192 3.932.57 5.162 1.92l.068.076.068-.075z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 2,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 18,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 34,
    r: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 18,
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 30,
    r: 1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 6,
    r: 1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 1
  })));
}

export default SvgHeartFavoriteFull;